/*
  Create by BaiZhiming 2015-11-03
*/
'use strict';
angular
    .module('util.ueditor', [
        'util.ueditorConfig',
        'util.ueditorServiceModule',
        'eyeProtectionModelModule',
        'ueditorPlugInModule',
        'ueditorBtnServiceModule',
        'ueditorForWeixinModule',
        '135editorModule',
        'autotypesetModule',
    ])
    .directive('ueditor', [
        '$timeout',
        'ueditorBtnService',
        '$sce',
        '$interval',
        'ueditorService',
        '$compile',
        'ueditorPlugIn',
        'localStorageService',
        '$sessionStorage',
        'processingMaterialService',
        'editingCenterService',
        function (
            $timeout,
            ueditorBtnService,
            $sce,
            $interval,
            ueditorService,
            $compile,
            ueditorPlugIn,
            localStorageService,
            $sessionStorage,
            processingMaterialService,
            editingCenterService
        ) {
            return {
                restrict: 'E',
                scope: {
                    list: '=',
                    type: '@',
                    versionid: '=',
                    infullscreen: '=', // 是否处在全屏状态
                    metadataid: '=',
                    draftType: '@', // 稿件类型
                    hasContent: '=', // 编辑器内是否有内容
                    callback: '&', // 封面图回掉函数
                    showCoverBtn: '@', // 是否展示封面图按钮
                    editFlag: '=', // 编辑页标识
                },
                replace: true,
                template:
                    // 调整编辑器页面，增加一键排版，增加分页，增加loading --Add by songjian
                    '<div>' +
                    '<div type=\'_basic\'>' +
                    "<script id='ueditor' style='width:100%;position:relative'></script>" +
                    "<div class='menu-public ueditor_menu'>" +
                    // 屏蔽分页功能
                    // "<div class='menu-bottom-basic pagenum pagenum-first pagenum-cur' _order='1' click='pageAdd($event)' dblclick='pagedelete($event)'>第 1 页</div>" +
                    // "<div class='menu-bottom-basic pagemore' _order='0' click='pageAdd($event)' dblclick='pagedelete($event)'>+</div>" +
                    // "<button class='key4format' click='keyformat()'>一键排版</button>" +
                    "<div class='trs_ueditor_selectionNum'></div>" +
                    '</div>' +
                    '</div>' +
                    "<div id='authorization_box'>" +
                    "<div style='margin-top:15px; padding-top:10px; margin-left:25px'>" +
                    "<img src='./lib/ueditor2/themes/default/images/loading2.gif' style='vertical-align:middle;' /><b style='padding:0 5px'>正在排版，请稍候</b><img src='./lib/ueditor2/themes/default/images/loading2.gif' style='vertical-align:middle;' />" +
                    '</div>' +
                    '</div>' +
                    '</div>',
                link: function (scope, element) {
                    ueditorService.rewriteAutotypesetCache(UE);
                    var editorToolBar = ueditorService.getToolBar();
                    let currUserInfo = $sessionStorage.get('curUserInfo');
                    let userId = currUserInfo ? currUserInfo.ID : '-1';
                    let ueditorPasteState = localStorageService.get('ueditor.pasteState');
                    if (angular.isUndefined(scope.type)) {
                        // 采编中心i我渠道剔除一些按键功能
                        editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], [33]);
                        editorToolBar.pasteplain = getPasteplaainState('iwo');
                    }
                    if (typeof scope.type === 'string' && scope.type.indexOf('newsPaper') >= 0) {
                        // 采编中心报纸渠道剔除一些按键功能
                        editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], [35, 33, 32, 3, 4, 5]);
                        editorToolBar.labelMap.allowCopyImg = false;
                        editorToolBar.pasteplain = true;
                        // 字数统计浮标
                    }
                    if (scope.type === 'weixin') {
                        // 采编中心微信渠道剔除一些按键功能
                        var indexArray = [45, 46, 40, 39, 38, 37, 41, /* 33, 32, 31, 27, 26, 9,*/ 8, 7, 6, 5, 4, 3];
                        editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
                        editorToolBar.pasteplain = false;
                    }
                    if (scope.type === 'website') {
                        var indexArray = [34];
                        editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
                    }
                    if (scope.type === 'newmedia') {
                        var indexArray = [34];
                        editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
                    }
                    editorToolBar.toolbars[0].splice(7, 0, 'pasteplain');
                    var ue = UE.getEditor('ueditor', editorToolBar);
                    // var ue = UE.getEditor('ueditor');
                    var domUtils = baidu.editor.dom.domUtils;
                    ue.ready(function () {
                        // 新增分页
                        angular.element('.ueditor_menu').on('click', function (event) {
                            var event = event || window.event;
                            var target = event.target || event.srcElement;
                            if ($(target).hasClass('menu-bottom-basic')) {
                                ue.execCommand('pagenum', target);
                            }
                        });
                        // 双击删除分页
                        angular.element('.ueditor_menu').on('dblclick', function (event) {
                            var event = event || window.event;
                            var target = event.target || event.srcElement;
                            if ($(target).hasClass('pagenum')) {
                                ue.execCommand('del-pagenum', target);
                            }
                        });
                        const editMode = editingCenterService.getEditMode(); // 根据要求给编辑器插入首尾标识,只有新建才加
                        if (editMode === 'add') {
                            ue.setContent(scope.list.HTMLCONTENT); // 为了融合编辑器使用
                            $timeout(function() { // 等待讯头添加完成
                                // ueditorService.initLocalVersion(scope, localcache);
                            }, 2000);
                        } else { // 这里是编辑器中插入的视频转码完成替换
                            processingMaterialService.transcodeVideo(scope.list).then(function (html) {
                                html ? scope.list.HTMLCONTENT = html : '';
                                ue.setContent(scope.list.HTMLCONTENT);
                                // ueditorService.initLocalVersion(scope, localcache);
                                getContentNum();
                            });
                        }


                        /**
                         * [getContentNum description] 获取文字字数
                         *
                         * @return  {[type]}   [return description]
                         */
                        function getContentNum() {
                            // 纯文本正文及字数
                            var preContent = ueditorService.getTextContent(ue.getContentTxt());
                            scope.list.DOCWORDSCOUNT = preContent
                                .replace(/\n/g, '')
                                .replace(/\u0020/g, '')
                                .replace(/\u3000/g, '').length; // 兼容大数据取稿字数算法不同问题
                            // 纯文本正文及字数
                            var preResult = $sce.getTrustedHtml("<div class='display_none ueditorWordCount'>已输入<span class='color-red'>{{list.DOCWORDSCOUNT}}</span>个字</div>");
                            var result = $compile(preResult)(scope);
                            // element.find('.edui-editor').append(result);
                            element.find('.edui-editor-toolbarboxinner').append(result);
                            var destroyWatch = scope.$watch('list.DOCWORDSCOUNT', function (newValue) {
                                if (newValue) {
                                    $timeout(function () {
                                        result.removeClass('display_none');
                                        destroyWatch();
                                    });
                                }
                            });
                        }

                        ue.getOpt('lang');
                        var promise_keyup;
                        var promise_contentChange;
                        ue.addListener('keyup', function () {
                            // 实时双向绑定开始
                            bindContent(promise_keyup);
                        });
                        ue.addListener('contentChange', function () {
                            // 实时双向绑定开始
                            bindContent(promise_contentChange);
                            // 编辑器的必填提示
                            $timeout(function () {
                                var content = ue.getContent();
                                if (content !== '') {
                                    scope.hasContent = true;
                                } else {
                                    scope.hasContent = false;
                                }
                            });
                        });
                        // 计算显示字数，并显示出来
                        domUtils.on(ue.body, 'mouseup', function (event) {
                            selectionNumPop(event);
                        });
                        domUtils.on(ue.body, 'keydown', function (event) {
                            selectionNumPop(event);
                        });
                        // 显示选中区域的字数
                        ue.addListener('selectionchange', function () {
                            // 查看痕迹后或进入源码模式下禁用编辑器按钮
                            if (this.body.contentEditable == 'false' || this.sourceMode === true) {
                                for (var k in ueditorBtn) {
                                    if (ueditorBtn[k] !== '') {
                                        ueditorBtn[k].addState('disabled');
                                    }
                                }
                            } else {
                                for (var j in ueditorBtn) {
                                    if (ueditorBtn[j] !== '') {
                                        ueditorBtn[j].removeState('disabled');
                                    }
                                }
                            }
                            var selectionStr = this.selection.getText();
                            if (selectionStr.length === 0) {
                                hideSelectionNum();
                            }
                        });
                        // 编辑器失焦是字数显示消失
                        ue.addListener('blur', function () {
                            hideSelectionNum();
                        });

                        /**
                         * [showSelectionNum description]
                         * @param   {[type]}  position  [position description]
                         * @return  {[type]}            [return description]
                         */
                        function showSelectionNum(position) {
                            var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                            selectionNumDiv.css('left', position.left + 'px');
                            selectionNumDiv.css('top', position.top + 'px');
                            selectionNumDiv.fadeIn('fast');
                        }

                        /**
                         * [hideSelectionNum methodname]显示选中字数统计
                         * @return {[type]} [description] null
                         */
                        function hideSelectionNum() {
                            $(document)
                                .find('.trs_ueditor_selectionNum')
                                .fadeOut('fast');
                        }

                        /**
                         * [showSelectionNum methodname]显示选中字数统计
                         * @return {[type]} [description] null
                         */
                        function selectionNumPop(event) {
                            var selectionStr = ue.selection.getText();
                            if (selectionStr.length !== 0) {
                                var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                                var position = {};

                                /* var e = event;
                        var sh = $window.pageYOffset || $window.document.documentElement.scrollTop || $window.document.body.scrollTop || 0;
                        position.left = (e.clientX - 40 < 0) ? e.clientX + 20 : e.clientX - 40;
                        position.top = (e.clientY - 40 < 0) ? e.clientY + sh + 20 : e.clientY + sh - 40;*/
                                selectionNumDiv.html(
                                    '已选中' +
                                    selectionStr
                                        .replace(/&nbsp;/g, '')
                                        .replace(/\u00a0/g, '')
                                        .replace(/\u0020/g, '')
                                        .replace(/\u3000/g, '')
                                        .replace(/\n/, '').length +
                                    '个字'
                                );
                                showSelectionNum(position);
                            } else {
                                hideSelectionNum();
                            }
                        }


                        // 如果存在本地版本缓存，则比较本地版本与当前版本的差异
                        if (hasLocalVersion(scope.list.METADATAID, scope.type)) {
                            ueditorService.compareLocalAndServe(scope, scope.type).then(function () {
                                scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                            });
                        } else {
                            localcache();
                            scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                        }


                        // MLFWEB-5014 修复全屏的bug
                        ue.addListener('fullscreenchanged', function (type, bfullscreen) {
                            scope.infullscreen = bfullscreen;
                            var $iframeHolder = $('.edui-editor-iframeholder');
                            $iframeHolder.css('width', '100%');
                            // 全屏需要出滚动条
                            // $timeout(function() {
                            // });
                            //
                            var doc = $iframeHolder.find('iframe')[0].contentWindow.document;
                            doc.body.style.overflow = bfullscreen ? 'auto' : 'auto';
                            if (!bfullscreen) {
                                doc.body.style.height = 'initial';
                            }
                            $timeout(function () {
                                ue.selection.getRange().collapsed = true;
                                ue.selection.getRange().startOffset = ue.selection.getRange().endOffset;
                                ue.execCommand('inserthtml', '<trsfullscreen></trsfullscreen>');
                                var doms = doc.getElementsByTagName('trsfullscreen');

                                for (var index = 0; index < doms.length; index++) {
                                    doms[index].parentNode.removeChild(doms[index]);
                                }

                                ue.fireEvent('contentChange');
                            });
                        });

                        autotypeForNewspaper();

                        if (typeof scope.type === 'string' && scope.type.indexOf('newsPaper') >= 0) {
                            ue.addListener('beforepaste', function () {
                                let isPlainPaste = ue.queryCommandState('pasteplain');
                                if (!isPlainPaste) {
                                    ue.execCommand('pasteplain');
                                }
                            });
                            // ue.addListener('afterpaste', function(){
                            //     autotypeForNewspaper();
                            // });
                        }
                    });
                    scope.$on('$destroy', function () {
                        $interval.cancel(scope.promise); // 销毁定时事件
                    });

                    /**
                     * 获取纯文本粘贴模式状态
                     *
                     * @param   {[type]}  way  [way description]
                     *
                     * @return  {[type]}       [return description]
                     */
                    function getPasteplaainState(way) {
                        if (!ueditorPasteState) {
                            return false;
                        }
                        if (!ueditorPasteState[userId]) {
                            return false;
                        }
                        if (!ueditorPasteState[userId][way]) {
                            return false;
                        }
                        return true;
                    }

                    /**
                     * [hasLocalVersion 当前稿件是否有本地缓存版本]
                     *
                     * @param   {[type]}  docId  [docId description]
                     * @param   {[type]}  type   [type description]
                     *
                     * @return  {[type]}         [return description]
                     */
                    function hasLocalVersion(docId, type) {
                        return ueditorService.hasLocalVersion(docId, type);
                    }

                    /**
                     * [bindContent description] 绑定数据和编辑器内容
                     * @param   {[type]}  promise  [promise description]
                     * @return  {[type]}           [return description]
                     */
                    function bindContent(promise) {
                        if (promise) {
                            $timeout.cancel(promise);
                            promise = null;
                        }
                        promise = $timeout(function () {
                            ueditorService.bindContent();
                            scope.list.DOCWORDSCOUNT = ueditorService.getDOCWORDSCOUNT(ue);
                        }, 500);
                        return promise;
                    }

                    /**
                     * [autotypeForNewspaper description] 报纸渠道自动排版
                     * @return  {[type]}  [return description]
                     */
                    function autotypeForNewspaper() {
                        if (typeof scope.type === 'string' && scope.type.indexOf('newsPaper') >= 0) {
                            ue.execCommand('removeformat');
                            var cookieOpt = ue.getPreferences('autotypeset');
                            var opt = cookieOpt ? cookieOpt : ue.options.autotypeset;
                            opt.fontfamily = { name: 'songti', val: '宋体,SimSun' };
                            opt.fontsize = { name: '三号', val: 21 };
                            opt.lineheight = { flag: true, val: 1.5 };
                            opt.indent = true;
                            // $('#authorization_box').show(); // 正在排版Loading
                            $(ue.body).addClass('TRS_UEDITOR');
                            // 为一键排版样式设置值
                            ue.options.autotypeset = opt;
                            ue.execCommand('autotypeset');
                            // setTimeout(function () {
                            //     $('#authorization_box').hide(); // 定时隐藏正在排版Loading
                            // }, 1000);
                            ue.fireEvent('contentchange');
                            ue.setPreferences('autotypeset', opt);
                        }
                    }

                    /**
                     * [localcache methodname]本地保存
                     * @return {[type]} [description] null
                     */
                    function localcache() {
                        ueditorService.saveToLocal(scope.list.METADATAID, scope.type, ue.getContent(), scope.versionid);
                    }
                    // 监控metadataid变化，并将正文更新进入本地版本
                    ueditorService.watchMetadataidAndUpdateLocalVersion(scope, scope.type);

                    /* 编辑器新增按钮开始*/
                    var ueditorBtn = [];
                    // 遍历按钮方法，实例化按钮，并返回按钮对象
                    if (scope.editFlag) {
                        for (var i in ueditorBtnService) {
                            ueditorBtnService[i](UE, scope, ue, i, scope.editFlag.media).then(function (btn) {
                                ueditorBtn[btn.index] = btn.obj;
                            });
                        }
                    }


                    /* 编辑器新增按钮结束*/
                    // 重写全屏方法
                    ueditorService.rewriteFullScreen(UE, 60);
                    // 编辑器中图片工具条
                    if (scope.type === 'newmedia' && scope.showCoverBtn) {
                        ueditorPlugIn.pictureToolbarForWeixin(ue, scope, domUtils, function (fileName) {
                            if (scope.callback()) {
                                scope.callback()(fileName);
                            }
                        });
                    } else {
                        ueditorPlugIn.pictureToolbar(ue, scope, domUtils);
                    }
                    // 视频的获取工具条
                    // ueditorPlugIn.videoToolbar_(ue, scope); //暂时不需要视频编辑条
                    /** 点击触发外部播放器*/
                    ueditorPlugIn.videoPlayer(ue, scope);
                    // app图文插件补丁
                    ueditorPlugIn.appImagePlugin(ue, domUtils, scope.editFlag.media);
                    // ueditorPlugIn.audioToolbar(ue, scope);//音频的获取工具条
                    scope.$on('$destroy', function () {
                        ueditorService.destroyCommonUe(ue);
                    });
                    ueditorPlugIn.spaceIndent(ue, domUtils);
                    // ueditorPlugIn.outlinkPicDownload(ue, domUtils);
                    ueditorPlugIn.clickSource(ue);
                    ueditorPlugIn.fixContentInImageWrap(ue);
                    // ueditorPlugIn.addContentBeforeHtml(ue);
                    ueditorPlugIn.fixPasteFromMicoWord(ue);
                },
            };
        },
    ]);
